export enum CustomPositions {
    PG = 'PG',
    SG = 'SG',
    SF = 'SF',
    PF = 'PF',
    C = 'C'
}